import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import { withTheme } from '@material-ui/core';

import { updateBroadcastToZoomToken } from '../../actions';

import ZoomBroadcastCaptionsPopup from './ZoomBroadcastCaptionsPopup';

const mapStateToProps = ({
  scribeConversation: { broadcastToZoomToken, status },
  scribeSession: { captioner: user },
}) => ({ broadcastToZoomToken, user, status });

export default withTranslation()(
  withTheme(
    withSnackbar(
      connect(
        mapStateToProps,
        { updateBroadcastToZoomToken }
      )(ZoomBroadcastCaptionsPopup)
    )
  )
);
